import styled from 'styled-components';

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  width: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
`;

export const TabSwitcherContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
`;

export const TabContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 24px 24px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid ${(props) => props.theme.colors?.border || '#E5E7EB'};
`;

export const PaginationInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const PaginationText = styled.span`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || '#6B7280'};
`;
